export default "__VITE_ASSET__Dev2B7Uy__"